import React, { FC } from "react";

const Loading: FC = () => {
  return (
    <div className="Loading">
      <div className="Loading__spinner" />
    </div>
  );
};

export default Loading;
